interface CardsContainerDimensions {
  cardWidth: number;
  cardHeight: number;
  maxCardsCount: number;
  containerHeight: number;
}

const REST_PAGE_HEIGHT = 8 + 165 + 6;
const MENU_MARGIN_BOTTOM = 48;
const ROW_GAP = 16;
const COLUMN_GAP = 30;
const CARDS_CONTAINER_PADDING_BOTTOM = 48;
const CARD_WIDTH_GAP = 2;

const MIN_CARDS_PER_PAGE = 2;

const moreThanMinimal = (
  dimensions: CardsContainerDimensions,
  cardsInRow: number,
): CardsContainerDimensions => {
  if (dimensions.maxCardsCount < MIN_CARDS_PER_PAGE && cardsInRow >= 1) {
    return {
      cardHeight: dimensions.cardHeight,
      cardWidth: dimensions.cardWidth,
      maxCardsCount: MIN_CARDS_PER_PAGE,
      containerHeight:
        cardsInRow >= MIN_CARDS_PER_PAGE
          ? dimensions.cardHeight + CARDS_CONTAINER_PADDING_BOTTOM
          : MIN_CARDS_PER_PAGE * (dimensions.cardHeight + ROW_GAP) +
            CARDS_CONTAINER_PADDING_BOTTOM,
    };
  }
  return dimensions;
};

export const getDashboardCardsContainerDimensions = (
  cardMinWidth: number,
  cardHeight: number,
  screenHeight: number,
  cardsContainerWidth: number,
  menuHeight: number,
  paginatorHeight: number,
): CardsContainerDimensions => {
  const freeHeight =
    screenHeight -
    REST_PAGE_HEIGHT -
    menuHeight -
    MENU_MARGIN_BOTTOM -
    paginatorHeight -
    CARDS_CONTAINER_PADDING_BOTTOM;

  const cardsInRow = Math.floor(
    (cardsContainerWidth -
      Math.floor(cardsContainerWidth / cardMinWidth) * COLUMN_GAP +
      COLUMN_GAP) /
      cardMinWidth,
  );

  const cardWidth =
    (cardsContainerWidth - (cardsInRow * COLUMN_GAP - COLUMN_GAP)) /
      cardsInRow -
    CARD_WIDTH_GAP;

  if (freeHeight <= 0) {
    return moreThanMinimal(
      { maxCardsCount: 0, containerHeight: 0, cardWidth, cardHeight },
      cardsInRow,
    );
  }

  const cardsInColumn = Math.floor(
    (freeHeight - Math.floor(freeHeight / cardHeight) * ROW_GAP + ROW_GAP) /
      cardHeight,
  );

  return moreThanMinimal(
    {
      maxCardsCount: cardsInColumn * cardsInRow,
      containerHeight: freeHeight + CARDS_CONTAINER_PADDING_BOTTOM,
      cardWidth,
      cardHeight,
    },
    cardsInRow,
  );
};
